import React, { Fragment, useEffect } from "react";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchBlogList } from "../actions/blog";
import { fetchDeleteBlog } from "../actions/blog";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

const BlogList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "blog";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { blogList } = useSelector((state) => state.blogReducer);

  useEffect(() => {
    dispatch(fetchBlogList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/blog-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteBlog(pageId));
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("blogList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      minWidth: 150,
    },
    {
      headerName: t("blogList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("blogList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("blogList.inactive");
          case "ACTIVE":
            return t("blogList.active");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("blogList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("blogList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={blogList}
        columnDefs={columnDefs}
        buttonLink={`/blog-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="blog-list"
      />
    </Fragment>
  );
};

export default BlogList;
